import { useState, useEffect } from "react";
import AppRoutes from "./app/routes";
import { useLocation } from "react-router-dom";

const App = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return isLoginPage ? (
    <AppRoutes />
  ) : (
    <div className="main-wrapper-content">
      <AppRoutes />
    </div>
  );
};

export default App;
